<script lang="ts">
	//Design system components
	import { Button, Text } from '@Shelly/shelly-design-system';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';
	//Stores
	import { user_data } from 'src/stores/account/user';
	//Services
	import { format } from 'svelte-i18n';
	//Components
	import CarPlayWizard from './CarPlayWizard.svelte';
	//Helpers
	import { capFirstChar } from 'src/helpers/utilities';

	let showModal = false;

	const toggleEdit = () => {
		showModal = !showModal;
	};
	//this component is used mostly as entry point for the wizard and as a check for installers access
</script>

<Button
	class={classMap({
		'width-md-m width-sm-full mb-s mr-s': true,
	})}
	disabled={$user_data?.installer}
	responsiveSize={{
		sm: 'm',
	}}
	on:click={toggleEdit}>{capFirstChar($format('process_edit'))}</Button
>
{#if showModal}
	<CarPlayWizard bind:showModal />
{/if}
{#if $user_data?.installer}
	<Text class="text-color-muted mt-m">
		{capFirstChar(
			$format('text_installer_disabled', {
				default: 'off limits for installers',
			}),
		)}
	</Text>
{/if}
